export default __webpack_public_path__ + "static/media/sicepat.4dbf8e73.png";